import axios from 'axios'
// import store from '@/store'
import { getAttachmentsPage } from '@/services/attachments.service'
import { GATEWAY_HOST } from '@/composables/useMapbox'

export async function generateWmsBoundingBoxes(wmsList) {
  let wmssWithBoundingBoxList = []
  const promises = wmsList.map((wmsSource) => getCapabilities(wmsSource))
  const result = await Promise.allSettled(promises)
  result.forEach((capability, index) => {
    if (capability.status === 'fulfilled') {
      var wmsCapabilitiesDoc = new DOMParser().parseFromString(capability.value, 'text/xml')
      // In future solution, latLonBoundingBox should probably be saved by layer instead of just picking the first one
      const latLonBoundingBox = wmsCapabilitiesDoc.querySelector('LatLonBoundingBox')
      if (!latLonBoundingBox) return
      const minx = latLonBoundingBox.getAttribute('minx')
      const miny = latLonBoundingBox.getAttribute('miny')
      const maxx = latLonBoundingBox.getAttribute('maxx')
      const maxy = latLonBoundingBox.getAttribute('maxy')
      wmssWithBoundingBoxList.push({
        ...wmsList[index],
        boundingBox: [minx, miny, maxx, maxy]
      })
    } else {
      wmssWithBoundingBoxList.push({
        ...wmsList[index]
      })
    }
  })
  wmssWithBoundingBoxList = wmssWithBoundingBoxList.filter((wms) => wms.boundingBox)
  return wmssWithBoundingBoxList
}

async function getCapabilities(wmsSource) {
  const keycloakToken = localStorage.getItem('currentKeycloakToken') ?? ''
  const capabilitiesResponse = wmsSource.url.includes(GATEWAY_HOST)
    ? await getCapabilitiesRequest(wmsSource.url, keycloakToken)
    : await getCapabilitiesRequest(wmsSource.url)
  return capabilitiesResponse?.data
}

function getCapabilitiesRequest(url, token) {
  const capabilitiesEndpoint = '?request=GetCapabilities&version=1.1.1&service=WMS'
  return axios.get(
    url + capabilitiesEndpoint,
    token
      ? {
          headers: {
            Authorization: 'Bearer ' + token
          },
          timeout: 7000
        }
      : undefined
  )
}

/* export function getWmsApiToken(belongsTo) {
  const headers = {
    'Access-Control-Allow-Origin': '*',
    Authorization: 'Bearer ' + store.state.oidcStore.access_token
  }
  return axios
    .get(`${process.env.VUE_APP_API_BASE_URL}/v1/auth/token/wms?belongsTo=${belongsTo}`, {
      headers: headers,
      params: {}
    })
    .then((response) => {
      // Response also contains refresh_token, scope and expires_in
      localStorage.setItem('wmsApiToken', response.data.access_token)
      return response.data.access_token
    })
} */

export async function getWmsList(entityId) {
  try {
    const response = await getAttachmentsPage(entityId, ['WMS'], 0, 30)
    return response?.content
  } catch (error) {
    return undefined
  }
}
